module.exports = __webpack_public_path__ + "img/Image 30.754c6d9f.png";